import React from 'react'
import { LayoutBand, Separator, colors, useContainerWidth, Paragraph, H1 } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'

import errorGraphic from './assets/error500.svg'

const centerCss = css`
  text-align: center;
`
const greyBackgroundCss = css`
  background-color: ${colors.gray03};
`
const fullWidthCss = css`
  width: 100%;
`
const fixedWidthCss = css`
  width: 660px;
  margin: auto;
`

const Error500 = () => {
  const [t] = useTranslation()
  const atWidth = useContainerWidth()

  const imageWidthCss = atWidth({
    default: fullWidthCss,
    lg: fixedWidthCss,
  })

  return (
    <LayoutBand css={[centerCss, greyBackgroundCss]}>
      <Separator size="xl" />
      <div css={imageWidthCss}>
        <img
          src={errorGraphic}
          alt={t('memories.error.500.alt', 'Computer screen re-loading after an error')}
          css={fullWidthCss}
        />
        <Separator size="lg" />
        <H1 size="H2">{t('memories.error.500.heading', 'Technical Difficulties')}</H1>
        <Separator size="xxs" />
        <Paragraph size="sm">
          {t(
            'memories.error.500.subheading',
            "We couldn't display the page. It's likely a temporary problem that can be fixed by reloading the page in your browser. If the problem persists, please try again later."
          )}
        </Paragraph>
      </div>
      <Separator size="xxl" />
    </LayoutBand>
  )
}

export default Error500
